export enum InsertBomStyle {
  BOM_STYLE_1 = 'BOM_STYLE_1',
  BOM_STYLE_2 = 'BOM_STYLE_2',
  BOM_STYLE_3 = 'BOM_STYLE_3',
  BOM_STYLE_4 = 'BOM_STYLE_4',
  BOM_STYLE_5 = 'BOM_STYLE_5',
  BOM_STYLE_6 = 'BOM_STYLE_6',
}
